import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { countryCode } from 'Helpers/Geo/data';
import DlcBadge from 'Components/Cards/DlcBadge';
import Drm from 'Components/Utility/Drm';
import HitCardButtons from 'Components/Cards/HitCardButtons';
import HitCardWishlistBtn from 'Components/Cards/HitCardWishlistBtn';
import PriceContainer from 'Containers/Utility/Price/PriceContainer';
import ProductCover from 'Components/Utility/ProductCover';

import 'Components/Cards/ProductListCard.scss';

export default function ProductListCard({
  hit,
  showReleaseDate,
  isMetacritic,
  index,
  listCardNameTag,
  listCardContainerTag,
}) {
  let validDrm = '';
  let filteredDrm = [];
  if (hit && hit.drm) filteredDrm = hit.drm.filter(d => d !== 'voucher');
  if (filteredDrm.length === 1) validDrm = filteredDrm[0];

  let noGermanRelease = false;
  if (countryCode === 'DE' && hit.no_release_date) {
    noGermanRelease = true;
  }

  let metacriticColour = 'green';
  if (hit.metacritic_score && hit.metacritic_score < 75) metacriticColour = 'yellow';
  if (hit.metacritic_score && hit.metacritic_score < 50) metacriticColour = 'red';

  const TagName = listCardNameTag;
  const TagContainer = listCardContainerTag;

  return (
    <TagContainer className="product-list-card faux-block-link">
      <div className={classNames('list-card-number', { [`metacritic metacritic--${metacriticColour}`]: isMetacritic })}>
        {isMetacritic ? hit.metacritic_score : index + 1}
      </div>
      <div className="list-card-cover-wrapper">
        <ProductCover
          cover={hit.cover}
          alt={`Product cover for ${hit.name}`}
          displayType={hit.display_type}
        />
      </div>
      <div className="list-card-strip">
        <TagName className="list-card-name">
          {hit.name &&
            <Link to={`${hit.type}/${hit.slug}`} className="faux-block-link__overlay-link">
              {hit.name}
            </Link>
          }
        </TagName>
        {showReleaseDate && hit.release_date &&
          <div className="list-card-release-date">
            <FormattedMessage
              id="product-list-card.release"
              defaultMessage="Release Date: {releaseDate}."
              values={{
                releaseDate: <FormattedDate value={hit.release_date * 1000} year="numeric" month="long" day="2-digit" />,
              }}
            />
          </div>
        }
        <div className="list-card-icon-price-container">
          <div className="drm-badges-container">
            {hit.drm &&
              <Drm drmType={validDrm} />
            }
            {hit.display_type === 'dlc' &&
              <DlcBadge />
            }
          </div>

          {hit.price && !hit.presale && !hit.free_to_play && !hit.hide_price &&
            <PriceContainer
              type={hit.type}
              discountPercent={hit.discount_percent}
              price={hit.price}
              tiered={hit.tiered}
              hideDiscount={hit.hide_discount}
              slug={hit.slug}
              discountPercentOverride={hit.discount_percent_override}
              showAsterisk={!!hit.addVoucher}
              fullPrice={hit.fullPrice}
              mystery={hit.mystery}
              drm={validDrm}
              payWhatYouWant={hit.pay_what_you_want}
            />
          }
          {hit.product_id &&
            <HitCardButtons
              hideViewButton
              hit={hit}
              noGermanRelease={noGermanRelease}
              payWhatYouWant={hit.pay_what_you_want}
            />
          }
        </div>
      </div>

      <HitCardWishlistBtn
        productId={hit.product_id}
        slug={hit.slug}
        hit={hit}
      />
    </TagContainer>
  );
}

ProductListCard.propTypes = {
  hit: PropTypes.shape({}),
  showReleaseDate: PropTypes.bool,
  isMetacritic: PropTypes.bool,
  index: PropTypes.number,
  listCardNameTag: PropTypes.string,
  listCardContainerTag: PropTypes.string,
};

ProductListCard.defaultProps = {
  hit: {},
  showReleaseDate: false,
  isMetacritic: false,
  index: 0,
  listCardNameTag: 'div',
  listCardContainerTag: 'div',
};
